<template>
    <v-system-bar app :height="48" v-bind="$attrs" color="primary" >
        <fe-dialog
            width=400
            title="Switch District"
            v-if="switchDistrictDialog.show"
            @dismiss="switchDistrictDialog.show=false"
            @close="switchDistrictDialog.show=false"
            @accept="doSwitchDistrict"
            :acceptButtonDisabled="!switchDistrictDialog.id"
            acceptButtonText="Switch"
            persistent
        >
            <div class="d-flex flex-column flex-fill">
                <fe-label>District ID</fe-label>
                <v-text-field
                    type="number"
                    v-model="switchDistrictDialog.id"
                    autofocus flat solo dense
                    @keyup="enter"
                />
            </div>
        </fe-dialog>

        <mobile-pin v-model="showMobilePin"/>
        <change-user-password v-model="showChangePassword"/>
        <user-preferences v-model="showUserPrefs"/>

        <fe-dialog
            width=400
            title="Switch User"
            v-if="switchUserDialog.show"
            @dismiss="switchUserDialog.show=false"
            @close="switchUserDialog.show=false"
            @accept="doSwitchUser"
            :acceptButtonDisabled="!switchUserDialog.rec"
            acceptButtonText="Switch"
            persistent
        >
            <div class="d-flex flex-column flex-fill">
                <fe-label>Select a User</fe-label>
                <fe-remote-combo
                    class="mt-2 ml-2"
                    :url="$models.getUrl('user', 'read') + '&active=1'"
                    itemText="user_full_name"
                    itemValue="id"
                    v-model="switchUserDialog.rec"
                    autofocus
                >
                    <template v-slot:item="data">
                        <v-list-item-content>
                            <v-list-item-title>{{data.item.user_full_name}}</v-list-item-title>
                            <v-list-item-subtitle class="pl-4">{{data.item.email_addr}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </fe-remote-combo>
            </div>
        </fe-dialog>

        <fe-dialog
            width=400
            title="Renaissance Academy"
            v-if="np.show"
            @dismiss="np.show=false"
            @close="np.show=false"
            @accept="np.show=false"
            persistent
            >
            <div style="line-height: 2.8;">
                <div style="font-weight: bold;">
                    {{ np.title }}
                </div>
                <div style="line-height: 1.5;">
                    {{ np.message }}
                </div>
                   Error {{ np.code }}
            </div>
        </fe-dialog>

        <v-layout row wrap>
            <v-flex xs12>
                <v-layout row>
                    <v-flex shrink class="nav-flex-center">
                        <div
                            data-test="nav-ec-logo"
                            class="logo logo-ec"
                            @click="go('/');
                            $emit('clear-selected')">
                        </div>
                    </v-flex>

                    <v-flex shrink class="nav-flex-center">
                        <span class="launchpad-nav-educlimber">{{ 'eduCLIMBER' }}</span>
                    </v-flex>

                    <v-flex shrink>
                        <div class="launchpad-nav">
                            <fe-btn
                                data-test="nav-district-search"
                                class="launchpad-nav-option first"
                                v-if="showDistrict"
                                @click="go('/Report/District');
                                $emit('clear-selected')"
                                :class="$route.path === '/Report/District' ? 'launchpad-nav-option-active' : 'launchpad-nav-option-inactive'"
                                :disabled="restricted"
                            >
                                District
                            </fe-btn>

                            <fe-btn
                                data-test="nav-grade-search"
                                class="launchpad-nav-option"
                                @click="go('/Report/Grade');
                                $emit('clear-selected')"
                                :class="[!showDistrict ? 'first' : 'middle', $route.path === '/Report/Grade' ? 'launchpad-nav-option-active' : 'launchpad-nav-option-inactive']"
                                :disabled="restricted"
                            >
                                Grade
                            </fe-btn>

                            <fe-btn
                                data-test="nav-class-search"
                                class="launchpad-nav-option last"
                                @click="go('/Report/Class');
                                $emit('clear-selected')"
                                :class="$route.path === '/Report/Class' ? 'launchpad-nav-option-active' : 'launchpad-nav-option-inactive'"
                                :disabled="restricted"
                            >
                                Class
                            </fe-btn>
                        </div>
                    </v-flex>

                    <v-spacer/>

                    <v-flex shrink class="text-xs-right nav-flex-center" v-if="showStudentSearch && !showSearch">
                        <v-menu
                            transition="slide-y-transition"
                            v-model="showStudentSearchMenu"
                            bottom offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <fe-btn v-on="on" usage="ghost" useIcon="arrow_drop_down" class="nav-student-search-menu-btn" useIconDirection="right">{{studentSearch.name}}</fe-btn>

                            </template>
                            <v-list class="nav-student-search-list">
                                <v-list-item style="cursor: pointer;" @click="setStudentSearch(null)">
                                    <v-list-item-content>Students</v-list-item-content>
                                </v-list-item>

                                <v-list-item @click="setStudentSearch(col)" style="cursor: pointer;" v-for="(col) in studentSearchDropdown" :key="col.id">
                                    <v-list-item-content>{{col.name}}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-autocomplete
                            v-model="selectedSearchRecord"
                            :search-input="searchText"
                            @update:search-input="searchText = $event"
                            flat solo dense
                            placeholder="Search for students"
                            class="nav-student-search-text"
                            :items="searchResults"
                            itemText="student_full_name"
                            itemValue="student_id"
                            return-object
                            append-icon=""
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>{{data.item.student_full_name}}</v-list-item-title>
                                    <v-list-item-subtitle>{{data.item.school_name}} {{data.item.grade_desc}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-flex>

                    <v-flex shrink class=" text-xs-right nav-flex-center ml-3">
                        <fe-tooltip :tooltip="'Calendar'">
                            <fe-btn
                                :disabled="restricted"
                                v-if="showCalendar"
                                useIcon="fas fa-calendar"
                                icon usage="ghost"
                                class="nav-icon-bar"
                                @click="tools('calendar')"
                                data-test="nav-calendar"
                                aria-label="Calendar"
                            ></fe-btn>
                        </fe-tooltip>

                        <poller :config="{key:'message_inbox_unread'}" #default="data">
                            <v-menu
                                :disabled="!inboxEnabled"
                                v-if="showEnvelope"
                                content-class="add-field-button"
                                :close-on-content-click="false"
                                offset-y
                                z-index="10"
                            >
                                <template #activator="{ on }">
                                    <fe-tooltip :tooltip="'Messages'">
                                        <fe-btn
                                            data-test="nav-messages"
                                            v-on="on"
                                            :disabled="restricted"
                                            icon
                                            useIcon="fas fa-envelope"
                                            usage="ghost"
                                            class="nav-icon-bar"
                                            :aria-label="data.unreadMsg ? `Messages, ${data.unreadCount} unread` : 'Messages'"
                                        >
                                            <v-badge
                                                v-if="data.unreadMsg"
                                                color="pink"
                                                :content="data.unreadCount"
                                                label="count"
                                                class="badge-offset"
                                            />
                                        </fe-btn>
                                    </fe-tooltip>
                                </template>
                                <inbox-dropdown :pollData="data" @unreadCount="data.unreadMsg = data.unreadCount = $event" />
                            </v-menu>
                        </poller>

                        <poller :config="{key:'new_bell_items'}" #default="data" @polled="(data) => $emit('newBellItems', data)">
                            <div>
                                <v-menu
                                    :disabled="!inboxEnabled"
                                    v-if="showEnvelope"
                                    content-class="add-field-button"
                                    :close-on-content-click="false"
                                    offset-y
                                    z-index="10"
                                >
                                    <template #activator="{ on }">
                                        <fe-tooltip :tooltip="'Notifications'">
                                            <fe-btn
                                                data-test="nav-notifications-bell"
                                                v-on="on"
                                                :disabled="restricted"
                                                icon
                                                useIcon="fas fa-bell"
                                                usage="ghost"
                                                class="nav-icon-bar"
                                                :aria-label="data.unreadCount ? `Notifications, ${data.unreadCount} new` : 'Notifications'"
                                            >
                                                <v-badge
                                                    v-if="data.unreadCount"
                                                    color="pink"
                                                    :content="data.unreadCount"
                                                    label="count"
                                                    class="badge-offset"
                                                />
                                            </fe-btn>
                                        </fe-tooltip>
                                    </template>
                                    <bell-dropdown :pollData="data" @unreadCount="data.unreadCount = data.unreadNotificationCount = $event" />
                                </v-menu>
                            </div>
                        </poller>
                        <poller :config="{key:'kpi_dashboard'}" @polled="onPolled" #default="data"></poller>

                        <v-menu offset-y v-model="showHelpMenu">
                            <template v-slot:activator="{ on }">
                                <fe-tooltip :tooltip="'Help'">
                                    <fe-btn
                                        data-test="nav-help-btn"
                                        v-on="on"
                                        icon
                                        usage="ghost"
                                        class="nav-icon-bar"
                                        :disabled="restricted"
                                        aria-label="Help"
                                    >
                                        <i class="far fa-question-circle" style="color: white; font-size: 18px;"></i>
                                    </fe-btn>
                                </fe-tooltip>
                            </template>
                            <v-list dense>
                                <v-list-item @click="openKnowledgeBase()" class="user-pref-icon d-flex" data-test="nav-help-knowledge-base">
                                    <v-icon class="mr-3 dropdown-menu-icon">fal fa-books</v-icon>
                                    
                                    <div class="flex-grow-1">
                                        <div class="font-weight-semibold">Knowledge Base</div>
                                        <div style="color: #495B8F; font-size: 14px;">Explore help articles</div>
                                    </div>
                                    
                                    <div class="d-flex align-center">
                                        <i class="far fa-external-link" style="color: #495B8F; font-size: 16px;"></i>
                                    </div>
                                </v-list-item>
                                
                                <v-list-item
                                    data-test="nav-help-chat-with-us"
                                    @click="openChatWithUs()"
                                    class="user-pref-icon mt-2"
                                >
                                    <v-icon class="mr-3 dropdown-menu-icon">fal fa-comment-dots</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-semibold">Chat with Us</v-list-item-title>
                                        <v-list-item-subtitle style="color: #495B8F; font-size: 14px;">
                                            Get your questions answered
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                
                                <v-list-item @click="() => {}" class="user-pref-icon d-flex mt-2" data-test="nav-help-product-feedback" v-if="pendoPortalFlag">
                                    <v-icon class="mr-3 dropdown-menu-icon">fal fa-comment-alt-edit</v-icon>
                                    
                                    <div class="flex-grow-1">
                                        <div class="font-weight-semibold">Product Feedback & Roadmap</div>
                                        <div style="color: #495B8F; font-size: 14px;">Share ideas and see what's next</div>
                                    </div>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-menu offset-y v-model="showAppSwitcher" v-if="availableApps.length > 0">
                            <template v-slot:activator="{ on }">
                                <fe-tooltip :tooltip="'Switch Illuminate Application'">
                                    <fe-btn 
                                        v-on="on"
                                        icon
                                        :class="'nav-icon-bar'"
                                        :disabled="restricted"
                                        aria-label="Switch Illuminate Application"
                                    >
                                            <v-img :src="logoAppSwitchImg" max-width="20px" max-height="20px" />
                                    </fe-btn>
                                </fe-tooltip>
                            </template>
                            <v-list dense>
                                <template v-for="opt in appSwitcherMenuItems">
                                    <v-list-item v-if="!opt.hidden" @click="opt.handler()" :class="opt.class">
                                        <v-img class="mr-3" max-width="20px" max-height="20px" :src="opt.icon" />
                                        <span class="font-weight-semibold">{{opt.name}}</span>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-menu>

                        <div class="ml-3 mr-3" style="width: 30px;">
                            <fe-tooltip tooltip="Renaissance Educator Academy">
                                <div 
                                    class="northpass-image"
                                    @click="northpassHandler"
                                    @keydown.enter="northpassHandler"
                                    @keydown.space.prevent="northpassHandler"
                                    data-test="nav-educator-academy"
                                    aria-label="Renaissance Educator Academy"
                                    role="button"
                                    tabindex="0"
                                    :style="{width: '30px', height: '30px', backgroundImage: 'url(' + renaissanceEducatorAcademyLogoImg + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}"
                                />
                            </fe-tooltip>
                        </div>

                        <v-menu offset-y v-model="showUserMenu" style="z-index: 98;">
                            <template v-slot:activator="{ on }">
                                <fe-tooltip :tooltip="sessionUser.user.user_full_name + ` (` + sessionUser.district.login_id + `)`" style="z-index: 98;">
                                    <fe-btn
                                        data-test="nav-user-account"
                                        v-on="on" v-if="showUser"
                                        :useIcon="topSecret ? 'fas fa-user-lock' : !sessionUser.user.photo_url ? 'fas fa-user' : ''"
                                        icon
                                        class="nav-icon-bar-circle"
                                        :class="showUserMenu ? 'nav-icon-bar-circle-active' : 'nav-icon-bar-circle-inactive'"
                                        :disabled="restricted"
                                        :aria-label="`User account, ${sessionUser.user.user_full_name}`"
                                    >
                                        <v-avatar size="28px" v-if="!topSecret && sessionUser.user.photo_url">
                                            <v-img :src="sessionUser.user.photo_url"/>
                                        </v-avatar>
                                    </fe-btn>
                                </fe-tooltip>
                            </template>

                            <div class="user-info-group">
                                <div class="user-name">{{sessionUser.user.user_full_name}}</div>
                                <div v-if="topSecret" class="user-info top-secret">Top Secret Mode</div>
                                <div class="user-info">{{sessionUser.user.email_addr}}</div>
                                <div class="user-info">{{sessionUser.district.name}}</div>
                            </div>
                            <v-list dense>
                                <template v-for="opt in userPrefs.filter(itm => !itm.hidden)">
                                    <template v-if="!opt.component">
                                        <v-list-item
                                            @click="opt.handler()"
                                            :class="opt.class ? [opt.class, 'user-pref-icon'].join(' ') : 'user-pref-icon'"
                                            :data-test="`nav-profile-${opt.name.toLowerCase().replace(/\s+/g, '-')}`"
                                        >
                                            <v-icon class="mr-3">{{opt.icon}}</v-icon>
                                            <span class="font-weight-semibold">{{opt.name}}</span>
                                        </v-list-item>
                                    </template>

                                    <template v-else>
                                        <component
                                            :is="opt.component"
                                            @click="opt.handler"
                                            :class="opt.class"
                                        />
                                    </template>
                                </template>
                            </v-list>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12 class="mb-2" v-if="1 == 2">
                <v-layout row>
                    <v-flex xs12>
                        <template v-for="(nav, navIndex) in navigations">
                            <div
                                class="nav-btn"
                                @click="handleNavigation(nav)"
                                :key="nav.name"
                            >
                                {{nav.name}}
                                <span style="padding-left: 5px;" v-if="navIndex != navigations.length-1">/</span>
                            </div>
                        </template>
                    </v-flex>
                    <v-flex class="text-xs-right">
                        <div class="district-name">
                            {{ schoolDistrict }}
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-system-bar>
</template>

<script>
import logoAppSwitchImg from '@/assets/images/logo-app-switch.png'
import logoDnaImg from '@/assets/images/logo-dna.png'
import logoEduclimberImg from '@/assets/images/logo-educlimber.png'
import logoFastbridgeImg from '@/assets/images/logo-fastbridge.png'
import logoIlluminateImg from '@/assets/images/logo-illuminate.png'
import renaissanceEducatorAcademyLogoImg from '@/assets/images/renaissance_educator_academy_logo.svg'
    import { mapState } from 'vuex'
    import Poller from '@/util/poller.js'
    import NavigationStepper from '@/components/common/NavigationStepper'
    import MobilePin from '@/components/modules/user/MobilePin'
    import ChangeUserPassword from '@/components/modules/user/ChangeUserPassword'
    import UserPreferences from '@/components/modules/user/UserPreferences'
    import InboxDropdown from '@/components/modules/messages/InboxDropdown'
    import BellDropdown from '@/components/modules/bell/BellDropdown'
    import UserTargetSetsPopout from '@/components/modules/user/UserTargetSetsPopout'
    import lodash from 'lodash'

    export default {
        name: 'NavigationBar',

        components: {
            Poller,
            NavigationStepper,
            MobilePin,
            ChangeUserPassword,
            UserPreferences,
            InboxDropdown,
            BellDropdown,
            UserTargetSetsPopout,
        },

        props: {
            showCalendar: { type: Boolean, default: true },
            showEnvelope: { type: Boolean, default: true },
            showBell: { type: Boolean, default: true },
            showTable: { type: Boolean, default: true },
            showUser: { type: Boolean, default: true }
        },

        data() {
            return {
                logoAppSwitchImg,
                renaissanceEducatorAcademyLogoImg,
                showUserPrefs: false,
                showAppSwitcher: false,
                switchDistrictDialog: {
                    show: false,
                    id: null
                },
                switchUserDialog: {
                    show: false,
                    rec: null
                },
                showMobilePin: false,
                showChangePassword: false,
                selectedPage: null,
                showStudentSearchMenu: false,
                searchText: '',
                searchResults: [],
                selectedSearchRecord: null,
                studentSearch: { id: 'students', name: 'Students' },
                studentSearchDropdown: [
                    { id: 'students', name: 'Students' }
                ],
                showSearch: true,
                showUserMenu: false,
                activeTable: false,
                preferences: {},
                availableApps: [],
                loadingNP: false,
                np: {
                    show: false,
                    title: '',
                    message: '',
                    code: null
                },
                showHelpMenu: false,
            }
        },

        computed: {
            ...mapState('global', ['recentNavigation', 'currentYear', 'sessionUser', 'restrictedUI', 'uris', 'shareableStores']),
            ...mapState('navigation', ['activeModule', 'manage', 'launchpad']),
            inboxEnabled: me => me.$store.getters['flags/flags']['ec-inbox'] === true,
            pendoPortalFlag() {
                return this.$store.getters['flags/flags']['pendo_portal']
            },
            showDistrict() {
                return this.$hasSecurity('VIEW_ALL_GRADES')
            },
            schoolDistrict() {
                return 'Climberville School District'
            },
            restricted() {
                return this.restrictedUI ? true : false
            },
            userName() {
                return 'Matt Harris'
            },
            navigations() {
                switch (this.activeModule) {
                    case 'manage':
                        return this.manage
                        break
                    case 'launchpad':
                        return this.launchpad
                        break
                    case 'District':
                        break
                }
            },
            showStudentSearch() {
                let sz = this.$vuetify.breakpoint
                return !sz.smAndDown
            },
            topSecret() {
                return this.sessionUser.user.force_top_secret || this.preferences.TOP_SECRET_MODE
            },
            userPrefs() {
                let me = this
                let prefs = []

                if (this.restrictedUI) {
                    prefs.push({
                        name: 'Not Available',
                        icon: 'fas fa-fw fa-exclamation'
                    })
                } else {
                    prefs.push({
                        name: 'User Preference',
                        icon: 'far fa-user-cog',
                        handler: function () {
                            me.showUserPrefs = true
                        }
                    }, {
                        name: 'Change CICO PIN',
                        icon: 'far fa-mobile',
                        handler: function () {
                            me.showMobilePin = true
                        }
                    }, {
                        name: 'Change Password',
                        icon: 'far fa-key',
                        handler: function () {
                            me.showChangePassword = true
                        }
                    }, {
                        component: 'user-target-sets-popout',
                        name: 'Target Sets',
                        icon: 'fas fa-map-marked',
                        handler: function () {
                            // The popout component itself will handle all click events
                            return
                        },
                    }, {
                        name: 'Classic View',
                        icon: 'far fa-step-backward',
                        class: 'start-section',
                        handler: function () {
                            window.location = me.uris['ec_classic']
                        }
                    }, {
                        name: 'Switch District',
                        icon: 'far fa-fw fa-random',
                        hidden: !me.shareableStores.can_switch_district,
                        handler: function () {
                            me.switchDistrictDialog.id = null
                            me.switchDistrictDialog.show = true
                        }
                    }, {
                        name: 'Switch User',
                        icon: 'far fa-user-friends',
                        hidden: !me.shareableStores.can_switch_user,
                        handler: function () {
                            me.switchUserDialog.rec = null
                            me.switchUserDialog.show = true
                        }
                    }, {
                        name: 'Revert to Original User',
                        icon: 'fas fa-fw fa-long-arrow-alt-left',
                        hidden: !me.shareableStores.revert_user_id,
                        handler: function() {
                            me.doSwitchUser({
                                id: me.shareableStores.revert_user_id
                            })
                        }
                    }, {
                        name: 'Log Out',
                        icon: 'far fa-sign-out',
                        handler: function () {
                            me.$messageBox({
                                title: 'Confirm Log Out',
                                persistent: true,
                                message: 'Are you sure you want to log out?',
                                maxWidth: '500',
                                actions: [{
                                    text: 'Cancel',
                                    primary: false
                                }, {
                                    text: 'Log Out',
                                    primary: true,
                                    onClick: () => {
                                        me.$axios.get('qry.php?property=logout&json=1').then(response => {
                                            // Clear collections state on logout
                                            localStorage.removeItem('lastCollectionId')
                                            Object.keys(localStorage).forEach(key => {
                                                if (key.startsWith('lastActiveTab_')) {
                                                    localStorage.removeItem(key)
                                                }
                                            })
                                            
                                            sessionStorage.removeItem('chronicAbsence_columnPreferences')
                                            
                                            window.location.href = response.data.redirect
                                        })
                                    }
                                }]
                            })
                        }
                    })
                }

                return prefs
            },
            appSwitcherMenuItems() {
                let apps = []
                let icons = {
                    'allthedata': logoDnaImg,
                    'educlimber': logoEduclimberImg,
                    'fastbridge': logoFastbridgeImg,
                    'illuminate': logoIlluminateImg,
                }
                this.availableApps.forEach((item) => {
                    if (!item.showProduct) return
                    apps.push({
                        name: item.displayName,
                        icon: icons[item.application] || icons.illuminate,
                        hidden: false,
                        handler: () => {
                            window.location.href = item.url
                        }
                    })
                })

                return apps
            },
        },

        watch: {
            searchText: lodash.debounce(function(v) {
                if (v && v.length >= 3) {
                    this.doSearch()
                }
            }, 500),
            selectedSearchRecord(v) {
                this.$store.commit('set', {
                    module: 'global',
                    state: 'selectedStudent',
                    value: v
                })
            }
        },

        mounted() {
            this.fetchUserPrefs()
            this.fetchAvailableApps()
            // if password is expiring soon, show change password dialog first thing
            if (this.shareableStores?.user?.password_expiring_soon) {
                this.showChangePassword = true
            }
        },

        methods: {
            chkunread(v) {},
            doSwitchDistrict() {
                let id = this.switchDistrictDialog.id

                if (!id) {
                    return
                }

                this.$setLoading(true)
                this.$axios.post('switchDistrict.php', { district_id: id} )
                    .then(response => {
                        this.cleanUpBeforeLocationChange()
                        let redirect = function () {
                            if (response.data.redirect) {
                                location = response.data.redirect
                            } else {
                                location.reload()
                            }
                        }
                        // log out of IE SSO session before changing location
                        if (response.data.ie_logout) {
                            let iframe = document.createElement('iframe')
                            iframe.onload = redirect
                            iframe.src = response.data.ie_logout
                            iframe.style.dispaly = 'none'
                            document.body.appendChild(iframe)
                        } else {
                            redirect()
                        }
                    })
                    .finally(() => {
                        this.$setLoading(false)
                    })
            },
            doSwitchUser(rec) {
                rec = rec || this.switchUserDialog.rec

                if (!rec) {
                    return
                }

                this.$axios.post('switchUser.php', { user_id: rec.id} )
                    .then(response => {
                        let data = this.$ecResponse(response)

                        if (data) {
                            this.cleanUpBeforeLocationChange();
                            if (data.redirect) {
                                window.location = data.redirect
                            } else {
                                window.location.reload(true)
                            }
                        }
                    })
            },
            cleanUpBeforeLocationChange() {
                // remove IE SSO iframe
                let iesso = document.getElementById('ie_session_iframe')
                if (iesso) iesso.parentNode.removeChild(iesso)
            },
            handleNavigation(nav) {
                if (nav.to) {
                    this.go(nav.to)
                }
            },
            go(link) {
                if (this.restrictedUI) {
                    this.$snackbars.$emit('new', { text: 'This feature is not yet enabled', usage: 'warning' })
                    return
                }

                if (link == '/') {
                    this.$store.commit('global/reloadLaunchpad', { })
                }

                this.$router.push(link)
            },
            setStudentSearch(col) {
                if (!col) {
                    this.studentSearch = {
                        id: 'students',
                        name: 'Students'
                    };
                } else {
                    this.studentSearch = col
                }
            },
            doSearch() {
                let params = '&name='+this.searchText + '&school_year_id='+this.currentYear.id
                this.$axios.get(this.$models.getUrl('studentGradeHistory', 'read')+params)
                .then(response => {
                    this.$data.searchResults = response.data
                })
                .catch(error => {
                    console.error(error)
                })
            },
            tools(icon) {
                let route = {
                    id: icon,
                    name: icon
                }
                this.$emit('top-nav', route)
            },
            navigation(route) {
                this.$emit('navigation', route)
            },
            fetchUserPrefs() {
                this.$modelGet('userPreferences')
                    .then(resp => {
                        let r = {}
                        resp.forEach(pref => { r[pref.code] = parseInt(pref.user_value) })
                        this.preferences = r
                    })
            },
            fetchAvailableApps() {
                if (!this.shareableStores.authx_enabled) return
                this.$axios.get(this.shareableStores.authx_provider + "/products", {cors: true, useDefaultXhrHeader: false, withCredentials: true})
                    .then(response => {
                        let data = response.data || []
                        this.availableApps = data
                    })
            },
            enter(e) {
                if (e.key === 'Enter' && this.switchDistrictDialog.show && this.switchDistrictDialog.id) {
                    this.doSwitchDistrict()
                }
            },
            northpassHandler() {
                this.$emit('np-loading', true)
                this.$axios.get(this.$models.getUrl('northpass','read'))
                    .then(response => {
                        if (response.data?.success) {
                                window.open(response.data?.northpass.url, '_blank')
                        } else {
                            this.np = response.data?.error
                            this.np.show=true
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    })
                    .finally(() => {
                        this.$emit('np-loading', false)
                    })
            },
            onPolled({dashboardCount}) {
                this.$store.commit('global/setKpiDashboardCount', {value: dashboardCount})
            },
            openKnowledgeBase() {
                window.open('https://educlimber.illuminateed.com/hc/en-us')
            },
            openChatWithUs() {
                if (this.$store.getters['flags/flags']['ec-forethought-chatbot']) {
                    window.Forethought('widget', 'show')
                    window.Forethought('widget', 'open')
                } else {
                    zE('webWidget', 'prefill', {
                        name: {
                            value: this.sessionUser.user.user_full_name
                        },
                        email: {
                            value: this.sessionUser.user.email_addr
                        }
                    });
                    zE.show();
                    zE.activate();
                }
            },
        }
    }
</script>
<style lang="scss">
.v-system-bar {
    .fe-button.primary {
        .v-icon {
            margin: 0;
            color: #fff;
        }
    }
}
</style>

<style lang="scss" scoped>
.badge-offset {
    position: absolute;
    right: 12px;
    top: 12px;
}

.logo {
    width: 35px;
    border-radius: 4px;
    text-align: center;
    transition: 500ms all;
    height: 30px;
    background-position: center;
    background-size: 20px;
    background-color: transparent;

    &:hover {
        cursor: pointer;
        background-color: white;
        border: 1px solid white;
        background-position: center;
        background-size: 20px;
        width: 35px;
    }

    &-ad {
        background-image: url(~@/assets/images/ad_logo.png);
        &:hover {
            background-image: url(~@/assets/images/ad_logo_color.png);
        }
    }

    &-ec {
        background-image: url(~@/assets/images/educlimber_white2.png);
        &:hover {
            background-image: url(~@/assets/images/educlimber2.png);
        }
    }
}

.user-info-group {
    background: white;
    padding: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.54);

    .user-name {
        font-size: 16px;
        padding: 0;
    }

    .user-info {
        font-size: 12px;
        min-height: unset;
        padding: 0;

        &.top-secret {
            color: #930A00;
        }
    }
}

.end-section {
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.54);
}

.start-section {
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.54);
}

.launchpad-nav {
    align-items: center;
    display: flex;
    height: 100%;

    .launchpad-nav-option {
        ::v-deep .fe-button {
            display: inline-block;
            min-width: 78px;
            max-width: 78px;
            height: 28px;
            color: white;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            text-align: center;
            padding: 0 !important;
            margin: 4px 1px;
            cursor: pointer;
            &:hover {
                background: #004156 !important;
            }
        }
        &-active {
            ::v-deep .fe-button{
                background: #004156 !important;
            }
        }
        &-inactive {
            ::v-deep .fe-button {
                background: var(--v-primary-darken1) !important;
            }
        }

        &.first ::v-deep .fe-button {
            border-radius: 4px 0px 0px 4px;
        }

        &.middle ::v-deep .fe-button {
            border-radius: 0;
        }

        &.last ::v-deep .fe-button {
            border-radius: 0px 4px 4px 0px;
        }

        &.standalone {
            border-radius: 4px;
            width: 71px;
            margin-left: 6px;
        }
    }

    &-educlimber {
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;
        padding: 16px 20px 16px 5px;
    }
}

.district-name {
    width: 200px;
    padding-right: 24px;
    padding-top: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    /* identical to box height */
    color: #FFFFFF;
}

.launchpad-menu {
    width: 432px;
    background: #FFFFFF;
    border: 1px solid #E0E1E6;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px rgba(126, 132, 148, 0.3);
    border-radius: 3px;

    .launchpad-menu-icon {
        font-size: 18px;
        color: #3F6190;
    }

    .launchpad-menu-display {
        display: inline-block;
        width: 50px;
        margin-top: 5px;
        border: 1px solid blue;
    }

    .launchpad-menu-img {
        height: 16px;
    }

    .launchpad-menu-text {
        height: 32px;
    }

    .launchpad-menu-description {
        color: #C0C3CF !important;
    }

    .launchpad-menu-item {

        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        /* identical to box height */
        color: #050F2D;
    }
}

.user-greeting {
    width: 318px;
    padding-left: 24px;

    /* Heading 1 */
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    /* identical to box height */
    color: #FFFFFF;
}

.northpass-image {
    cursor: pointer
}

.nav-btn {
    color: white;
    padding-top: 14px;
    padding-right: 8px;
    font-size: 14px;
    float: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.nav-student-search {
    &-menu-btn {
        min-width: 120px;
        ::v-deep .fe-button {
            background: #fff !important;
            height: 28px;
        }
        ::v-deep .v-btn {
            margin: 0 !important;
            padding: 0 !important;
            border: 1px solid #C0C3CF;
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            min-width: 120px;
        }
        ::v-deep i {
            font-size: 20px !important;
        }
        ::v-deep .v-btn__content {
            padding-left: 5px;
        }
    }
    &-menu-btn:hover {
        background: #ECEDF1 !important;
        border-radius: 4px;
    }

    &-search-list {
        padding: 0 !important;
        ::v-deep .v-list__tile {
            height: 40px !important;
            min-width: 125px !important;
            font-size: 13px;
        }
    }

    &-text {
        padding-top: 21px !important;
        width: 220px;
        ::v-deep .v-input__slot {
            border-radius: 4px !important;
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
            margin: 0 !important;
            min-height: 28px;
            max-height: 28px;
        }
    }
}

.nav-flex-center {
    display: flex;
    align-items: center;
}

.nav-icon-bar {
    ::v-deep .v-btn {
        height: 28px !important;
        width: 28px !important;
        .v-icon {
            margin-right: 0 !important;
        }
    }
    ::v-deep i {
        color: rgba(255, 255, 255, 0.8) !important;
    }
    &-circle {
        ::v-deep .v-btn {
            height: 28px !important;
            width: 28px !important;
            &:hover {
                background: #004156 !important;
            }
        }
        ::v-deep i {
            font-size: 12px !important;
        }
        &-active ::v-deep .v-btn {
            background: #004156 !important;
        }
        &-inactive ::v-deep .v-btn {
            background: var(--fe-secondary) !important;
        }
    }
}

.user-pref-icon {
    ::v-deep i {
        width: 22px;
        color: black;
    }
}

.user-pref-icon:hover {
    ::v-deep i {
        transform: none;
    }
}

.font-weight-semibold {
  font-weight: 600 !important;
}
</style>
